export const LOAD_RESULTS = 'LOAD_RESULTS_SURVEY';
export const CLEAN_RESULTS_SURVEY = "CLEAN_RESULTS_SURVEY";
export const SAVE_COMMENT_RESULT = "SAVE_COMMENT_RESULT";
export const SAVE_AUDIT = "SAVE_AUDIT";
